export default __webpack_public_path__ + "static/media/Beer-1.1f7cb4bf.png";